export default "__VITE_PUBLIC_ASSET__b29f2e55__"